import { useMemo } from 'react';
import { ForwardState } from './MainFooterActions';

export default ({ mainState, tabs }) => {
    return useMemo(() => {
        const elements = [];
        const filterPathes = (path: string, prop: keyof ForwardState): void => {
            const data = mainState?.[path]?.[prop];
            if (!data) {
                return;
            }
            for (const item of data) {
                if (!mainState[item]) {
                    elements.push(item);
                } else {
                    filterPathes(item, 'multi');
                    filterPathes(item, 'exclusive');
                }
            }
        };
        tabs.forEach(tab => {
            filterPathes(tab.key, 'multi');
            filterPathes(tab.key, 'exclusive');
        });

        return elements;
    }, [mainState]);
};
